import type { Position, Size } from './types';

export const TESTING_SEED_OVERRIDE = '978307200000';

export const DEFAULT_RENDERING_OFFSET: Position = { x: 0.5, y: 0.3 } as const;
export const DEFAULT_MAP_DRAWING_AREA: Size = {
  w: 258,
  h: 164,
} as const;
